import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderTaskDeleted(props: TypicalMessageProps) {
    return <TypicalMessage model={props.model} options={props.options}/>;
}
